// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5dae177e827ebda3dbdf","256":"b4ac2d1adf5cfe89449f","370":"870fe9800f96a3299eda","699":"b1151eed4287e533e3a7","777":"33f0cd1082923979c169"}[chunkId] + ".js";
};